/**
 * @param {string} value
 * @return {string}
 */
export const formatMoneyValue = (value, currencySettings) => {
  let result;
  if (typeof value == "number") {
    result = Number(value).toFixed(2);
  } else {
    result = value && value.replace(/[^\w.]+/g," ");
  }
  if (typeof(APP_ADMIN) != 'undefined') {
    result = result + " " + currencySettings.currency
  } else {
    if (GIST.enabled_currencies_length == 1) {
      result = result + " " + currencySettings.currency
    }
  }
  return result;
}

export const getCurrencySymbol = (locale, currency) => {
  return (0).toLocaleString(
    locale,
    {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  ).replace(/\d/g, '').trim()
}
